<template>
  <!-- :options="options" -->
  <UnSwitcherNew
    trigger="click"
    class="w-100"
    swKey="sw_range_compare"
    tstPrefix="rangecompare"
    :hasText="true"
    :hasOpener="true"
    :closeOnContentClick="true"
    style="--uns-opener-clr-back: rgba(255, 255, 255, 0.1)"
  >
    <template #menu_after="v">
      <div class="bt-grey my-1"></div>
      <div
        class="gw_btn gw_btn_text gw_btn_small clr-grey text-small f-justify-start bt-grey"
        style="--padding: 0.5rem"
        @click="
          v.methods.toggleOpen(false),
            $store.dispatch('router_set_dialogs', 'study-eq-buckets-help-dialog')
        "
      >
        <i class="mdi mdi-help-circle-outline mr-1 text-medium" />
        {{ $t('common.help') }}
      </div>
    </template>
  </UnSwitcherNew>
</template>

<script>
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
// import { allSwitchers } from '@/store/switchers/switchers'

export default {
  name: 'StudyEqBucketsSwitcherNew',
  // methods: {
  // handleShowEquityBucketsOnlyChange() {
  //   const currentValue = this.$store.getters.sw_range_compare

  //   if (!this.options.find(({ payload }) => payload === currentValue)) {
  //     this.$store.dispatch('switchers_set_item', {
  //       key: 'sw_range_compare',
  //       item: this.options[0],
  //     })
  //   }
  // },
  // },
  components: {
    UnSwitcherNew,
  },
  props: {
    hasHelp: { type: Boolean, default: true },
    showEquityBucketsOnly: Boolean,
  },
  computed: {
    // options() {
    //   return this.showEquityBucketsOnly
    //     ? allSwitchers().sw_range_compare.filter(({ isEQBucket }) => isEQBucket)
    //     : allSwitchers().sw_range_compare
    // },
  },
  // watch: {
  //   showEquityBucketsOnly: {
  //     immediate: true,
  //     handler: 'handleShowEquityBucketsOnlyChange',
  //   },
  // },
}
</script>
